export default __webpack_public_path__ + "static/media/firefox_2018-04-08_18-07-45.2e6a789a.png";